module.exports = __webpack_public_path__ + "static/media/loader.53bc64a9.svg";